<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <!-- 顶部搜索区域 -->
    <div class="global-mb16">
      <y-form
        :formInfo="formInfo"
        @search="search"
      >
      </y-form>
    </div>
    <!-- 活动列表 -->
    <div class="global-felx-1">
      <y-table
        :tableData="tableData"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :tableInfo="tableInfo"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: total,
        }"
        @handlePage="handlePage"
      >
      </y-table>
    </div>
  </div>
</template>

<script>
import { getScoreGradeUpdateRecord } from "@/api/memberMessageSystem";
export default {
  name: "gradeRecord",
  components: {},
  data() {
    return {
      total: 0,
      formDataList: {
        memberId: null, //全渠道会员ID
        changeSource: "", //变更来源
        changeType: "", //变更类型
        updateType: "0",
        startTime: "", //开始时间-开始
        endTime: "", //结束时间-截止
        // 页码
        pageNum: 1,
        pageSize: 10,
      },
      // 变更类型
      changeTypeList: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 1,
          label: "升级",
        },
        {
          value: 3,
          label: "降级",
        },
        {
          value: 2,
          label: "保级",
        },
      ],
      // 变更来源
      changeSourceList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "手动导入会员",
        },
        {
          value: 2,
          label: "会员正常升级",
        },
        {
          value: 3,
          label: "会员等级失效降级",
        },
        {
          value: 4,
          label: "会员等级失效保级",
        },
        {
          value: 5,
          label: "手动调整",
        },
      ],

      talbeLoading: false,
      tableData: [],

      formInfo: [
        {
          label: "全渠道会员ID：",
          prop: "memberId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "变更类型：",
          prop: "changeType",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 1,
              label: "升级",
            },
            {
              value: 3,
              label: "降级",
            },
            {
              value: 2,
              label: "保级",
            },
          ],
        },
        {
          label: "变更来源：",
          prop: "changeSource",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "全部",
            },
            {
              value: 1,
              label: "手动导入会员",
            },
            {
              value: 2,
              label: "会员正常升级",
            },
            {
              value: 3,
              label: "会员等级失效降级",
            },
            {
              value: 4,
              label: "会员等级失效保级",
            },
            {
              value: 5,
              label: "手动调整",
            },
          ],
        },
        {
          label: "变更时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
        },
      ],
      tableInfo: [
        {
          prop: "memberId",
          label: "全渠道会员ID",
          width: "150px",
        },
        {
          prop: "changeSource",
          label: "变更来源",
          width: "230px",
          formatter: (row) => {
            if (row.changeSource == 1) {
              return "手动导入会员";
            } else if (row.changeSource == 2) {
              return "会员正常升级";
            } else if (row.changeSource == 3) {
              return "会员等级失效降级";
            } else if (row.changeSource == 4) {
              return "会员等级失效保级";
            } else if (row.changeSource == 5) {
              return "手动调整";
            } else {
              return "-";
            }
          }
        },
        {
          prop: "changeBeforeGrade",
          label: "变更前等级",
          align: "right",
        },
        {
          prop: "changeAfterGrade",
          label: "变更后等级",
          align: "right",
        },
        {
          prop: "changeType",
          label: "变更类型",
          formatter: (row) => {
            if (row.changeType == 1) {
              return "升级";
            } else if (row.changeType == 2) {
              return "保级";
            } else if (row.changeType == 3) {
              return "降级";
            } else {
              return "-";
            }
          }
        },
        {
          prop: "expiryDate",
          label: "等级有效期时间",
        },
        {
          prop: "remark",
          label: "备注",
          showOverflowTooltip: true,
        },
        {
          prop: "createTime",
          label: "变更时间",
        },
      ]
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "会员信息管理", "等级变更记录");
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log(this.MemberSystemInfo, "11");
  },
  mounted() {
    // 获取等级变更列表
    this.getActivityList();
  },
  methods: {
    search(obj) {
      for (const key in obj) {
        this.formDataList[key] = obj[key];
      }
      this.formDataList.pageNum = 1;
      this.formDataList.pageSize = 10;
      this.getActivityList();
    },
    // 获取活动列表
    getActivityList() {
      this.talbeLoading = true;
      getScoreGradeUpdateRecord({
        ...this.formDataList,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
      })
        .then((res) => {
          this.talbeLoading = false;
          if (res.code == 200) {
            this.tableData = res.data.dataList;
            this.total = res.data.pageInfo.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {});
    },
    handlePage(page) {
      this.formDataList.pageNum = page.pageNum;
      this.formDataList.pageSize = page.pageSize;
      this.getActivityList();
    },
    // 分页
    handleSizeChange(val) {
      this.formDataList.pageSize = val;
      this.getActivityList();
    },
    handleCurrentChange(val) {
      this.formDataList.pageNum = val;
      this.getActivityList();
    },
    getClean() {
      this.formDataList = {
        memberId: null, //全渠道会员ID
        changeSource: "", //变更来源
        changeType: "", //变更类型
        updateType: "0",
        startTime: "", //开始时间-开始
        endTime: "", //结束时间-截止
        // 页码
        pageNum: 1,
        pageSize: 10,
      };
      this.getActivityList();
    },
  },
};
</script>